export const CUSTOMIZE_HEADER_TITLE = "Customize";
